import {Card, Col, Row} from "antd";
import Icon, {FileProtectOutlined, HomeOutlined, SunOutlined, TruckOutlined, UserOutlined} from "@ant-design/icons";
import TweenOne from "rc-tween-one";
import React, {ReactNode} from "react";
import useVisibility from "@/src/hooks/onScreenVisibility";
import {useTranslations} from "next-intl";

import Water from "@/public/assets/svg/water.svg";
import {ThemeService} from "@/src/services/theme";

const AnimatedStatsComponent = () => {
    const visibilityOffset = 15
    const [isPhotovoltaicVisible, photovoltaicRef] = useVisibility<HTMLDivElement>(visibilityOffset);
    const [isAccomodationVisible, accomodationRef] = useVisibility<HTMLDivElement>(visibilityOffset);
    const [isHostsVisible, hostsRef] = useVisibility<HTMLDivElement>(visibilityOffset);
    const [isLitersVisible, litersRef] = useVisibility<HTMLDivElement>(visibilityOffset);
    const localization = useTranslations('stats');
    const themeColors = ThemeService.getThemeColors()
    const cardStyle: React.CSSProperties = {
        height: "100%",
        width: "100%",
        border: "1px solid #eee"
    }

    const imageStyle = {fontSize: 44, marginRight: 16, color: themeColors.menuBarColor}

    const getStat = (key: string, ref: React.RefObject<HTMLDivElement>, refVisible: Boolean, image: ReactNode, itemValue: number, textNode: ReactNode) => {
        return (
            <Col xs={24} sm={12} md={6} key={key}>
                <Card variant={"borderless"} ref={ref} style={cardStyle}>
                    <div style={{color: themeColors.primary }}>
                                     <span>
                                        {image}
                                    </span>
                        <TweenOne
                            component="span"
                            animation={refVisible ? {
                                Children: {
                                    value: itemValue,
                                    floatLength: 0
                                },
                                duration: 1000,
                            }: {
                                Children: {
                                    value: 0,
                                    floatLength: 0
                                },
                                duration: 1000,
                            }}
                            style={{ fontSize: 48, marginBottom: 12 }}
                        >
                            0
                        </TweenOne>
                    </div>

                    <div style={{fontSize: 20}}>{textNode}</div>
                </Card>
            </Col>
        )
    }

    return (
        <>
            <Row gutter={[16, 16]} style={{margin: "16px"}}>
                {(() => {
                    return (
                        [
                            getStat("1", accomodationRef, isAccomodationVisible, <HomeOutlined style={imageStyle} />, 4, localization.rich('stat1', {important: (chunks) => <b>{chunks}</b>})),
                            getStat("2", hostsRef, isHostsVisible, <UserOutlined style={imageStyle} />, 18, localization.rich('stat2', {important: (chunks) => <b>{chunks}</b>})),
                            getStat("3", photovoltaicRef, isPhotovoltaicVisible, <SunOutlined style={imageStyle} />, 6000, localization.rich('stat3', {important: (chunks) => <b>{chunks}</b>})),
                            getStat("4", litersRef, isLitersVisible, <Icon component={Water} style={imageStyle} />, 600, localization.rich('stat4', {important: (chunks) => <b>{chunks}</b>})),
                        ]
                    )
                })()}
            </Row>
        </>
    )
}

export default AnimatedStatsComponent